import saMessages from '../locales/tr_TR.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'tr-TR',
};
export default saLang;
